/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyIsNullAnnotationKey: core.serialization.ObjectSchema<
    serializers.KeyIsNullAnnotationKey.Raw,
    Truvity.KeyIsNullAnnotationKey
> = core.serialization.object({
    key: core.serialization.string(),
});

export declare namespace KeyIsNullAnnotationKey {
    export interface Raw {
        key: string;
    }
}
